import {Component, ContentChild, Input} from "@angular/core";
import {FUIButtonComponent} from "../button.component";
import {FUIMarkToggleComponent} from "../../../toggle/mark-toggle/mark-toggle.component";
import {FUIIconComponent} from "../../../icons/icon/icon.component";

@Component({
    selector: "fui-pop-button",
    styleUrls: ["./pop-button.component.scss"],
    templateUrl: "./pop-button.component.html",
    standalone: false
})
export class FUIPopButtonComponent extends FUIButtonComponent {
    @ContentChild(FUIIconComponent) public icon: FUIIconComponent;
    @ContentChild(FUIMarkToggleComponent) public toggle: FUIMarkToggleComponent;
    @Input() public toggled: boolean;
}
